import React from 'react';
import { Button, Typography } from 'antd';
import classNames from 'classnames';
import { IconFont } from '../../../component/icon-font';

interface LeaveButtonProps {
  onLeaveClick: () => void;
}

const { Title } = Typography

const LeaveButton = (props: LeaveButtonProps) => {
  const { onLeaveClick } = props;

  return (
    <Button
      className={classNames('vc-leave-button')}
      icon={<IconFont type="icon-leave" />}
      // eslint-disable-next-line react/jsx-boolean-value
      ghost={true}
      shape="default"
      size="large"
      onClick={onLeaveClick}
      title="Leave session"
    >
      <Title level={2} style={{color: "#fff", paddingBottom: 8 }}>EXIT</Title>
    </Button>
  );
};

export default LeaveButton